import ComicCard from '@/components/base/ComicCard';
import { allComics } from '@/mocks/comics';

export default function NewUpdates() {
  const latest = [...allComics].sort((a, b) => b.updateDate.localeCompare(a.updateDate)).slice(0, 8);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            最新更新
          </h2>
          <p className="text-sm text-foreground-500 mt-1">实时追踪韩漫更新动态，不错过每一话</p>
        </div>
        <a
          href="/category/recommend"
          className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap"
        >
          更多更新
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {latest.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}